import * as React from "react";
import { useState } from "react";
import {
  KahunaWidgetConfiguration,
  WidgetAlignment,
  WidgetButtonLayout,
} from "./d";
import { CommonStateWrapper } from "./state/commonStateWrapper";
import { PatientContext } from "./state/patientContext";
import { ChatWidgetContainer } from "./widget/chatWidgetContainer";
import { MemoryRouter, Route, Switch } from "react-router";
import { MainLayout } from "./layout/MainLayout";
import { NavigationContext } from "./state/navigationContext";
import { INFOMED_CLINIC_ID, INFOMED_PARTNER_ID } from "./widget/partnerIds";

function WidgetApp(config: KahunaWidgetConfiguration) {
  let lastRoute = JSON.parse(
    sessionStorage.getItem((config.sessionId || "") + "location") || "{}",
  ) as object;

  const [initialEntry, setInitialEntry] = useState(lastRoute);

  const updateLastRoute = () => {
    lastRoute = JSON.parse(
      sessionStorage.getItem((config.sessionId || "") + "location") || "{}",
    );
    setInitialEntry(lastRoute);
  };

  const clinicId =
    config.clinicId ||
    (config.partnerId === INFOMED_PARTNER_ID ? INFOMED_CLINIC_ID : null);

  return (
    // since PatientContext is dependent on ConversationContextProvider it's
    // not part of common state wrapper, the rest such as dao, partnerId,
    // translations and conversation context
    // Avi - 29.06.22: Since our state provider now also handles redirects it's became
    //                 dependent on the router
    <MemoryRouter initialEntries={[initialEntry]}>
      <CommonStateWrapper widgetSettings={{ ...config, clinicId }} embedded>
        <NavigationContext>
          <PatientContext sessionId={config.sessionId}>
            <ChatWidgetContainer
              onClose={updateLastRoute}
              sessionId={config.sessionId}
              chatIcon={config.icon}
              startAsOpen={config.open === true || false}
              initialEntry={initialEntry}
              buttonLayout={config.buttonLayout || WidgetButtonLayout.icon}
              buttonText={config.buttonText}
              alignment={config.windowAlignment || WidgetAlignment.left}
              allowClose={config.allowClosing}
              navigationBar={config.navigationBar}
              configObject={config} // A workaround to make the state change each time we get a new config object so we can useEffect(,[configObject])
            >
              <Switch>
                <Route
                  path="/"
                  render={() => (
                    <MainLayout
                      embedded
                      sessionId={config.sessionId}
                      locale={config.locale}
                    />
                  )}
                />
              </Switch>
            </ChatWidgetContainer>
          </PatientContext>
        </NavigationContext>
      </CommonStateWrapper>
    </MemoryRouter>
  );
}

export default WidgetApp;
